import React from "react";
import { StyledDoubleStructure } from "./DoubleStructure.styled";
import { AlignmentEnum } from "../../../types/AppTypes";

type DoubleStructureProps = {
  children: React.ReactNode;
  variant?: string;
  verticalAlignment: AlignmentEnum;
  wrap?: "start" | "end";
};

export const DoubleStructure = ({
  children,
  variant,
  verticalAlignment,
  wrap = undefined,
}: DoubleStructureProps) => {
  return (
    <StyledDoubleStructure
      $variant={variant}
      $verticalAlignment={verticalAlignment}
      $wrap={wrap}
    >
      {children}
    </StyledDoubleStructure>
  );
};
